export var downloadFiles = function downloadFiles(file, fileName) {
    var url = window.URL.createObjectURL(new Blob([file]));
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
};
